export default {"src":"/_next/static/media/technologies-logo-6.63d43294.svg","height":86,"width":85,"blurWidth":0,"blurHeight":0};